export function loadReCaptcha(siteKey: string) {
  // console.log(`Loading reCAPTCHA script for site key: ${siteKey}`);
  return new Promise<void>((resolve, reject) => {
    const existingScript = document.querySelector(`script[src*="recaptcha/enterprise.js?render=${siteKey}"]`);
    if (existingScript) {
      console.log('reCAPTCHA script already loaded');
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('ReCaptcha script failed to load');
    document.head.appendChild(script);
  });
}